/**
 * @file オプション申込（追加）情報を管理するステート
 *
 * ユーザーが申込もうとしているオプションの情報（オプション名・コード・オーダー種別）を保持する。
 * オプション追加画面（option-entry）で選択されたオプションの詳細を
 * 確認画面・完了画面へ引き継ぐために使用される。
 * セッションストレージに永続化される。
 */
import { Constants } from '@/utils/constants';
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/** オプション申込情報の型 */
export type EntryOptionInfoStateType = {
  /** オプション名称 */
  option_name: string;
  /** オプション詳細 */
  option_info: {
    /** オプションコード */
    option_code: string;
    /** オプションクラス種別 */
    option_class_type: string;
    /** オーダー種別（Constants.OptionOrderTypeで定義） */
    order_type: number;
  };
};

export const entryOptionInfoState = atom<EntryOptionInfoStateType>({
  key: 'entryOptionInfoState',
  default: {
    option_name: '',
    option_info: {
      option_code: '',
      option_class_type: '',
      order_type: Constants.OptionOrderType.SIMPLE_ENTRY,
    },
  },
  effects_UNSTABLE: [persistAtom],
});

export default entryOptionInfoState;
